import React from 'react'
import { Document } from '../landingpage/components/document';
import { Footer } from '../landingpage/components/footer';
import './notfound.css';

export class NotFound extends React.Component {
    render() {
        return (
            <>
                <title>404 - Page Not Found</title>

                <Document classes="notfound">
                    <div>
                        <h1>404 - Page Not Found</h1>
                        <p>The page you're looking for doesn't exist.</p>
                    </div>
                </Document>
                <div>
                    <Footer/>
                </div>
            </>
        )
    }
}

